import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Index',
    component: () =>
        import ('@/views/Index/index.vue'),
    children: [{
            path: '/',
            name: 'homePage',
            component: () =>
                import ('@/views/homePage/index.vue'),
            meta: {
                title: '网站首页'
            }
        },
        //网站首页
        {
            path: '/homePage',
            name: 'homePage',
            component: () =>
                import ('@/views/homePage/index.vue'),
            meta: {
                title: '网站首页'
            }
        },
        //搜索页
        {
            path: '/search/:title',
            name: 'search',
            component: () =>
                import ('@/views/search/index.vue'),
            meta: {
                title: '搜索页'
            }
        },
        {
            path: '/search/del/:id',
            name: 'del',
            component: () =>
                import ('@/views/search/del.vue'),
            meta: {
                title: '搜索页'
            }
        },
        //集团概况
        {
            path: '/groupProfile/:id',
            name: 'groupProfile',
            component: () =>
                import ('@/views/groupProfile/index.vue'),
        },
        //新闻中心
        {
            path: '/pressCenter/:id',
            name: 'pressCenter',
            component: () =>
                import ('@/views/pressCenter/index.vue'),
        },

        //党群工作 businessUnit
        {
            path: '/businessUnit/:id',
            name: 'businessUnit',
            component: () =>
                import ('@/views/businessUnit/index.vue'),
        },

        //工程展示
        {
            path: '/projectShow/:id',
            name: 'projectShow',
            component: () =>
                import ('@/views/projectShow/index.vue'),
        },
        //职工文苑
        {
            path: '/culture/:id',
            name: 'culture',
            component: () =>
                import ('@/views/culture/index.vue'),
        },
        //招聘专栏
        {
            path: '/newsPaper/:id',
            name: 'newsPaper',
            component: () =>
                import ('@/views/newsPaper/index.vue')
        },
        //联系我们
        {
            path: '/contactUs',
            name: 'contactUs',
            component: () =>
                import ('@/views/contactUs/index.vue')
        },
        //信息公开
        {
            path: '/showInformation/:id',
            name: 'showInformation',
            component: () =>
                import ('@/views/showInformation/index.vue')
        },

        // 纪检举报
        {
            path: '/report',
            name: 'report',
            component: () =>
                import ('@/views/report/index.vue'),
        },
    ],
}, ]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router